import { useEffect, RefObject, MutableRefObject } from 'react';

const useMoveLast = (
	inputbox_ref:
		| RefObject<HTMLInputElement | HTMLTextAreaElement>
		| MutableRefObject<HTMLInputElement | HTMLTextAreaElement | undefined>,
) => {
	useEffect(() => {
		const MoveLastPlace = (e: Event) => {
			const el = e.target as HTMLInputElement | HTMLTextAreaElement;

			if (!el) return;

			setTimeout(() => {
				el.setSelectionRange(el.value.length, el.value.length);
				el.scrollLeft = el.value.length * 30;
			}, 0);
		};

		inputbox_ref.current?.addEventListener('focusin', (e) => MoveLastPlace(e));
		return inputbox_ref.current?.removeEventListener('focusin', MoveLastPlace);
	}, [inputbox_ref]);
};

export default useMoveLast;
